export type PaymentMethod = 'credit-card' | 'pix';

interface Props {
  value: PaymentMethod;
  onChange: (value: PaymentMethod) => void;
  hidePixOption?: boolean;
}

export default function PaymentMethodSwitch({ value, onChange, hidePixOption = false }: Props) {
  const isSelected = (method: PaymentMethod) => value === method;

  return (
    <div className="flex w-full rounded-xl border border-gray-300 p-1 bg-[#F9F9FB]">
      <button
        type="button"
        onClick={() => onChange('credit-card')}
        className={`flex-1 py-3 rounded-xl text-center font-semibold transition-all cursor-pointer ${
          isSelected('credit-card') ? 'bg-white shadow-sm text-[#595D69]' : 'text-[#A0A3AD]'
        }`}
      >
        Cartão de crédito
      </button>

      {!hidePixOption && (
        <button
          type="button"
          onClick={() => onChange('pix')}
          className={`flex-1 py-3 rounded-xl text-center font-semibold transition-all cursor-pointer ${
            isSelected('pix') ? 'bg-white shadow-sm text-[#595D69]' : 'text-[#A0A3AD]'
          }`}
        >
          Pix
        </button>
      )}
    </div>
  );
}
